import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import * as DateTime from 'react-datetime';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { IDrillString, IInterval, IIntervalCasing, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import DataTable from '../../../../DataTable';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';

interface IList {
    headers: any[];
    rows: any[];
}

const btnStyle = {
    marginRight: '10px'
};

@inject('stores')
@observer
class CasingAndInterval extends React.Component {
    public props: any;
    private dataSetOne: IList;
    private test: ITest = new ITest();
    public TestsStore: TestsStore;
    private MessageStore: MessageStore;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private interval: IInterval = new IInterval();

    public state = {
        dataSetOne: this.dataSetOne,
        editing: false,
        interval: this.interval,
        intervalEditable: [] as boolean[],
        intervalOpen: [true],
        intervalSubTypes: [],
        intervalTypes: [],
        isDirty: false,
        modal: false,
        saveClicked: false,
        showPlugback: [] as boolean[],
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);
        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.MessageStore = this.props.stores.MessageStore;
    }

    public componentDidMount() {
        this.createDisposers();
        this.getIntervalTypes();
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test = toJS(this.props.stores.TestsStore.test);
            const showPlugback = this.populateShowPlugback(test);
            this.setState({
                showPlugback,
                test,
                well: toJS(this.props.stores.WellsStore.well)
            }, () => {
                this.formatDataTableOne();
            });

        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            const showPlugback = this.populateShowPlugback(test);
            this.setState({
                showPlugback,
                test
            }, () => {
                this.formatDataTableOne();
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    private formatDataTableOne() {
        const newDataList: any[] = [];
        const tableHeaders = [
            '',
            'OD (in)',
            'ID (in)',
            'Length (ft)',
            'Cap (bbl/ln ft)',
            'Disp (bbl/ln ft)'
        ];
        if ( this.state.test.drillStringAssembly ) {
            this.state.test.drillStringAssembly.slice().map((item: IDrillString, index: number) => {
            const newObject = [
                {
                    content: item.itemType
                },
                {
                    content: item.outerDiameter
                },
                {
                    content: item.innerDiameter
                },
                {
                    content: item.length
                },
                {
                    content: item.cap
                },
                {
                    content: item.disp
                }
            ];
            newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            dataSetOne: listStructure
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private getIntervalTypes() {
        this.TestsStore.getIntervalTypes()
        .then(
            (data: any) => {
                this.setState({
                    intervalTypes: data
                });
            }
        );
    }

    private handleIntervalOpen = (index: number) => () => {
        const intervalOpen = this.state.intervalOpen;
        intervalOpen[index] = !intervalOpen[index];
        this.setState({
            intervalOpen,
        });
    }

    private handleIntervalEditable = (index: number) => () => {
        const intervalEditable = this.state.intervalEditable;
        intervalEditable[index] = !intervalEditable[index];
        this.setState({
            intervalEditable,
        });
    }

    private handleShowPlugback = (index: number) => () => {
        const showPlugback = this.state.showPlugback;
        showPlugback[index] = !showPlugback[index];
        const test = this.state.test;
        if (showPlugback[index] === false) {
            test.intervals[index].plugBackDepth = '' as unknown as number;
            test.intervals[index].plugBackDepthTVD = '' as unknown as number;
        }
        this.setState({
            showPlugback,
            test,
        });
    }

    private populateShowPlugback = (test: ITest) => {
        const intervals = test.intervals;
        if( Array.isArray(intervals)) {
            return intervals.map(value => Number(value.plugBackDepth) !== 0 || Number(value.plugBackDepthTVD) !== 0);
        }

        return [];
    }

    private handleDelete = (index: number) => () => {
        const areYouSure = confirm("Are you sure you want to delete this Interval?");
        if (areYouSure) {
            const { intervalOpen, intervalEditable, showPlugback, test } = this.state;
            const intervals = test.intervals;
            showPlugback.splice(index, 1);
            intervalOpen.splice(index, 1);
            intervalEditable.splice(index, 1);
            intervals.splice(index,1);
            test.intervals = intervals;
            this.updateSubInts(test);
            this.adjustTops(test);
            this.setState({
                intervalEditable,
                intervalOpen,
                isDirty: true,
                showPlugback,
                test
            });
        }
    }

    private handleCasingDelete = (intIndex: number, casingIndex: number) => () => {
        const areYouSure = confirm("Are you sure you want to delete this Interval Casing?");
        if (areYouSure) {
            const test = this.state.test;
            const interval = test.intervals[intIndex];
            const casings = interval.casings;
            casings.splice(casingIndex, 1);
            this.adjustTops(test);
            this.setState({
                isDirty: true,
                test
            });
        }
    }

    private handleNewCasing = (index: number) => () => {
        const casing = new IIntervalCasing();
        const test = this.state.test;
        casing.createdWellTestId = test.id;
        const interval = test.intervals[index];
        if (Array.isArray(interval.casings)) {
            if (interval.casings.length > 0) {
                const prevCasing = interval.casings[0];
                casing.casingTop = prevCasing.casingBottom;
                casing.casingTopTVD = prevCasing.casingBottomTVD;
            }
            interval.casings.unshift(casing);
        } else {
            interval.casings = [casing];
        }
        this.setState({
            isDirty: true,
            test,
        });
    }

    private handleCancel = () => {
        this.setState({
            editing: false,
            interval: new IInterval(),
            modal: false,
        });
    }

    private handleInputChange = (index: number) => (event: any) => {
        const test = this.state.test;
        const intervals = test.intervals;
        const tarName = event.target.name;
        const currInt = intervals[index];
        currInt[tarName] = event.target.value;
        this.adjustTops(test);
        this.setState({
            isDirty: true,
            test,
        });
    }

    private handleModalChange = (event: any) => {
        const interval = this.state.interval;
        interval[event.target.name] = event.target.value;
        this.setState({
            interval,
            isDirty: true,
        });
    }

    private handleCasingInputChange = (index: number, casIndex: number) => (event: any) => {
        const test = this.state.test;
        const intervals = test.intervals;
        const interval = intervals[index];
        const casing = interval.casings[casIndex];
        const tarName = event.target.name;
        casing[tarName] = event.target.value;
        this.adjustTops(test);
        this.setState({
            isDirty: true,
            test,
        });
    }

    private adjustTops = (test: ITest) => {
        const intervals = test.intervals;
        let currentTop = 0;
        let currentTopTVD = 0;
        for (let i = intervals.length - 1; i >= 0; i--) {
            const currInt = intervals[i];
            currInt.topFt = currentTop;
            currInt.topFtTVD = currentTopTVD;
            if (Array.isArray(currInt.casings) && currInt.casings.length > 0) {
                const casInd = currInt.casings.length - 1;
                const highestDepths = { topFt: currInt.casings[casInd].casingTop, topFtTVD: currInt.casings[casInd].casingTopTVD};
                for (let j = currInt.casings.length - 1; j >= 0; j--) {
                    const currCas = currInt.casings[j];
                    currCas.casingTop = highestDepths.topFt;
                    currCas.casingTopTVD = highestDepths.topFtTVD;
                    highestDepths.topFt = currCas.casingBottom;
                    highestDepths.topFtTVD = currCas.casingBottomTVD;
                }
                currentTop = highestDepths.topFt;
                currentTopTVD = highestDepths.topFtTVD;
            } else {
                currentTop = currInt.bottomFt;
                currentTopTVD = currInt.depthTVD;
            }
            if (currInt.plugBackDepth) {
                currentTop = currInt.plugBackDepth;
                currentTopTVD = currInt.plugBackDepthTVD;
            }

        }
    }
    private addOrdinals = (ordinalList: any[]) => {
        ordinalList.forEach((value: any, index: any) => {
            value.ordinal = index;
            if (Array.isArray(value.casings)) {
                this.addOrdinals(value.casings);
            }
        });
    }
    private updateTestModel = (event?: any) => {
        this.addOrdinals(this.state.test.intervals);
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                const validatateCalc = this.TestsStore.testDrillStringAndInterval(test);
                if (validatateCalc) {
                    this.MessageStore.addMessage('Calculations were successfully executed based on your drill string, interval and casing inputs.', 'success');
                } else {
                    this.MessageStore.addMessage('Calculations were not successfully executed based on your drill string, interval and casing inputs.', 'danger');
                }
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private handleStartDateTimeChange = (newDate:any) => {
        const interval = this.state.interval;
        const newDateValue = moment(newDate).tz(this.state.well.timeZoneName).unix();
        if (isFinite(newDateValue)) {
            interval.startDate = newDateValue.toString();
        }
        this.setState({
            interval,
        });
    }

    private handleStopDateTimeChange = (index:number) => (newDate:any) => {
        const test = this.state.test;
        const interval = test.intervals[index];
        interval.stopDate = moment(newDate).tz(this.state.well.timeZoneName).unix().toString();
        this.setState({
            isDirty: true,
            test,
        });
    }

    private checkInnerLessThanOuter = (index?: number, casIndex?: number) => () => {
        if (index !== undefined && casIndex !== undefined) {
            const interval = this.state.test.intervals[index];
            const casing = interval.casings[casIndex];
            if (Number(casing.casingID) !== 0 && Number(casing.casingOD) !== 0) {
                return Number(casing.casingID) >= Number(casing.casingOD);
            }
            return false;
        }
        const intervals = this.state.test.intervals;
        for (const myInt of intervals) {
            if (Array.isArray(myInt.casings)) {
                for (const myCas of myInt.casings) {
                    if (Number(myCas.casingID) !== 0 
                        && Number(myCas.casingOD) !== 0
                        && Number(myCas.casingID) >= Number(myCas.casingOD)
                    )
                    {
                        return true;
                    }
                }
            }
        }

        return false;
        
    }

    private toggleModal = () => {
        this.setState({
            interval: new IInterval(),
            modal: !this.state.modal
        });
    }

    private handleSave = () => {
        const { interval, intervalOpen, intervalEditable, showPlugback, test } = this.state;
        interval.createdTestId = test.id;
        interval.bottomFt = test.depthMD;
        interval.depthTVD = test.depthTVD;
        const newDepths = this.getNextIntervalTops(test);
        interval.topFt = newDepths.topFt;
        interval.topFtTVD = newDepths.topFtTVD;
        interval.subInt = this.getNextSubInt(test, interval.intervalType);
        if (test && test.bitData) {
            interval.estHoleSize = Number(test.bitData.estHoleSize);
        }
        if (test && test.intervals && test.intervals[0] && test.intervals[0].stopDate === '') {
            test.intervals[0].stopDate = interval.startDate;
        }
        test.intervals.unshift(interval);
        showPlugback.unshift(false);
        intervalOpen.unshift(true);
        intervalEditable.unshift(true);
        this.setState({
            interval: new IInterval(),
            intervalEditable,
            intervalOpen,
            isDirty: true,
            modal: false,
            showPlugback,
            test,
        });
    }

    private getNextIntervalTops = (test: ITest) => {
        const currInterval = test.intervals[0];
        if (currInterval) {
            if (currInterval.plugBackDepth) {
                return { topFt: currInterval.plugBackDepth, topFtTVD: currInterval.plugBackDepthTVD};
            }
            if (!currInterval.casings || (Array.isArray(currInterval.casings) && currInterval.casings.length === 0)) {
                return { topFt: currInterval.bottomFt, topFtTVD: currInterval.depthTVD };
            }
            if (Array.isArray(currInterval.casings) && currInterval.casings.length > 0) {
                const highestDepths = { topFt: 0, topFtTVD: 0};
                currInterval.casings.forEach(value => {
                    if (value.casingBottom > highestDepths.topFt) {
                        highestDepths.topFt = value.casingBottom;
                        highestDepths.topFtTVD = value.casingBottomTVD;
                    }
                });
                return highestDepths;
            }
        }

        return { topFt: 0, topFtTVD: 0};
    }

    private getNextSubInt = (test: ITest, intervalType: string) => {
        const filteredIntervals = test.intervals.filter(int => int.intervalType === intervalType);
        const nextSubInt = filteredIntervals.length + 1;
        return nextSubInt.toString();
    }

    private updateSubInts = (test: ITest) => {
        const intervalTypes = {};
        for(let i = test.intervals.length - 1; i >= 0; i--) {
            const currInt = test.intervals[i];
            if (intervalTypes[currInt.intervalType]) {
                currInt.subInt = (++intervalTypes[currInt.intervalType]).toString();
            } else {
                intervalTypes[currInt.intervalType] = 1;
                currInt.subInt = "1";
            }
        }
    }

    private renderIntervalAccordian = (interval: IInterval, index: number) => {
        const intervalEditable = !this.state.intervalEditable[index];
        const intervalDelible = interval.createdTestId === this.state.test.id && this.state.test.testStatus !== "Approved";
        const wellActive = this.state.well.wellStatus === 'Active';
        return (
    <React.Fragment>
        <Row>
        <Col>
        <h4 className="accordian-h4">
            <span onClick={this.handleIntervalOpen(index)}>
                <OpenArrow open={this.state.intervalOpen[index]}/>
                {' '}
                {interval.intervalType}
                {' '}
                {interval.subInt}
                {' '}
                | Started {interval.startDate !== '' ? moment.unix(Number(interval.startDate)).tz(this.state.well.timeZoneName).format("MMM DD YYYY, h:mm a") : ''}
                {' '}
                | Ended {interval.stopDate !== '' ? moment.unix(Number(interval.stopDate)).tz(this.state.well.timeZoneName).format("MMM DD YYYY, h:mm a") : 'No Date Set'}
            </span>
            {
                wellActive &&
                <span style={{marginLeft: '2rem'}}>
                    <input
                        type="checkbox"
                        name={"wellRemarksEditable" + index}
                        id={"wellRemarksEditable" + index}
                        checked={this.state.intervalEditable[index]}
                        onClick={this.handleIntervalEditable(index)}
                    />
                    Enable Editing
                </span>
            }
            {
                intervalDelible &&
            <span style={{marginLeft: '2rem'}} onClick={this.handleDelete(index)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </span>  
            }
        </h4>
        </Col>
        </Row>
        
        {
            this.state.intervalOpen[index] &&
        <React.Fragment>
        <Row>
            <Col md="11" style={{textAlign: 'left'}}>
            {
                !intervalEditable && index === 0 && 
                <Button color="primary" style={btnStyle} disabled={intervalEditable} onClick={this.handleShowPlugback(index)}>{this.state.showPlugback[index] ? 'Remove Plugback' : 'Add Plugback'}</Button>
            }
            {
                !intervalEditable && (index === 0 || index === 1) &&
                <Button color="primary" style={btnStyle} disabled={intervalEditable} onClick={this.handleNewCasing(index)}>Add New Casing</Button>
            }
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label>Top of Interval MD (ft)</Label>
                    <EInput
                        type="text"
                        name="topFt"
                        id="topFt"
                        value={ interval.topFt }
                        disabled={true}
                        onChange={this.handleInputChange(index)}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Top of Interval TVD (ft)</Label>
                    <EInput
                        type="text"
                        name="topFtTVD"
                        id="topFtTVD"
                        value={ interval.topFtTVD }
                        disabled={true}
                        onChange={this.handleInputChange(index)}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Depth MD (ft)</Label>
                    <EInput
                        type="text"
                        name="bottomFt"
                        id="bottomFt"
                        value={ interval.bottomFt }
                        disabled={intervalEditable}
                        onChange={this.handleInputChange(index)}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Depth TVD (ft)</Label>
                    <EInput
                        type="text"
                        name="depthTVD"
                        id="depthTVD"
                        value={ interval.depthTVD }
                        disabled={intervalEditable}
                        onChange={this.handleInputChange(index)}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Start Date</Label>
                    <DateTime
                        value={ interval.startDate ? moment.unix(Number(interval.startDate)).tz(this.state.well.timeZoneName) : undefined }
                        inputProps={{disabled:true}}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Stop Date</Label>
                    <DateTime
                        value={ interval.stopDate ? moment.unix(Number(interval.stopDate)).tz(this.state.well.timeZoneName) : undefined }
                        onChange={this.handleStopDateTimeChange(index)}
                        inputProps={{disabled:intervalEditable || this.state.well.wellStatus !== 'Active'}}
                    />
                </FormGroup>
            </Col>
        </Row>
        <div style={{borderBottom: '1px solid', borderColor: 'var(--line-break-color)', marginBottom: '2rem'}} />
        { ( ( Array.isArray(interval.casings) && interval.casings.length === 0 )
            || !interval.casings )
        &&
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label>Estimated Hole Size (in)</Label>
                    <EInput
                        type="text"
                        name="estHoleSize"
                        id="estHoleSize"
                        data-validation="decimal"
                        value={ interval.estHoleSize }
                        disabled={intervalEditable}
                        onChange={this.handleInputChange(index)}
                    />
                </FormGroup>
            </Col>
        </Row>
        }
        {
            this.state.showPlugback[index] &&
            <Row>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Plug Back Depth MD</Label>
                        <EInput
                            type="text"
                            name="plugBackDepth"
                            id="plugBackDepth"
                            key="plugBackDepth"
                            data-validation="decimal"
                            required={true}
                            disabled={intervalEditable}
                            value={ interval.plugBackDepth }
                            onChange={this.handleInputChange(index)}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Plug Back Depth TVD</Label>
                        <EInput
                            type="text"
                            name="plugBackDepthTVD"
                            id="plugBackDepthTVD"
                            key="plugBackDepthTVD"
                            data-validation="decimal"
                            required={true}
                            disabled={intervalEditable}
                            value={ interval.plugBackDepthTVD }
                            onChange={this.handleInputChange(index)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        }
        { interval.casings && interval.casings.map((casing, casIndex) => 
            <Row key={casing.id ? casing.id : casIndex}>
                <Col md="11">
                <Row>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing OD (in)</Label>
                        <EInput
                            type="text"
                            name="casingOD"
                            id="casingOD"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingOD }
                            disabled={intervalEditable}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                            errorCallback={{
                                callback: this.checkInnerLessThanOuter(index, casIndex),
                                message: 'Casing ID must be less than Casing OD.'
                            }}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing ID (in)</Label>
                        <EInput
                            type="text"
                            name="casingID"
                            id="casingID"
                            key="casingID"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingID }
                            disabled={intervalEditable}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                            errorCallback={{
                                callback: this.checkInnerLessThanOuter(index, casIndex),
                                message: 'Casing ID must be less than Casing OD.'
                            }}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing Top MD</Label>
                        <EInput
                            type="text"
                            name="casingTop"
                            id="casingTop"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingTop }
                            disabled={intervalEditable || casIndex !== interval.casings.length - 1}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing Top TVD</Label>
                        <EInput
                            type="text"
                            name="casingTopTVD"
                            id="casingTopTVD"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingTopTVD }
                            disabled={intervalEditable || casIndex !== interval.casings.length - 1}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing Bottom MD</Label>
                        <EInput
                            type="text"
                            name="casingBottom"
                            id="casingBottom"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingBottom }
                            disabled={intervalEditable}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup className="required">
                        <Label>Casing Bottom TVD</Label>
                        <EInput
                            type="text"
                            name="casingBottomTVD"
                            id="casingBottomTVD"
                            data-validation="decimal"
                            required={true}
                            value={ casing.casingBottomTVD }
                            disabled={intervalEditable}
                            onChange={this.handleCasingInputChange(index, casIndex)}
                        />
                    </FormGroup>
                </Col>
                </Row>
                </Col>
                {
                    casing.createdWellTestId === this.state.test.id && this.state.test.testStatus !== 'Approved' &&
                <Col md="1">
                    <div style={{marginTop: '1rem'}} onClick={this.handleCasingDelete(index, casIndex)}>
                        <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                    </div>  
                </Col>
                }
            </Row>
        )}
            
        </React.Fragment>
    }
    </React.Fragment>
        );
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/drillstring');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/survey');
        }
    }

    public render() {
        const disableWellStatus = this.WellsStore.well && this.WellsStore.well.wellStatus !== 'Active';
        return(
            <div className="CasingAndInterval">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Current Assembly 
                        { `: ${this.state.test.drillStringAssembly.reduce((total: number, currItem) => {
                            return total + Number(currItem.length);
                            }, 0)} `
                        }
                            ft
                        </h4>
                        <DataTable list={this.state.dataSetOne}/>
                    </Col>
                </Row>
                {
                    !disableWellStatus &&
                    <Row>
                        <Col md="12">
                            <h2 className="interval-header">Intervals
                                <Button color="primary" style={{marginLeft: '2rem', fontFamily: 'Roboto'}} onClick={this.toggleModal}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    {' '}Add Interval
                                </Button>    
                            </h2>
                        </Col>
                    </Row>
                }
                { this.state.test.intervals.map((value, index) => 
                    this.renderIntervalAccordian(value, index)
                )}
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} saveGrey={this.checkInnerLessThanOuter()()} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Add New Interval</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <p style={{fontSize: "1.25rem",fontWeight: "bold", color:"red"}}>
                                    Please ensure the previous interval has updated casing and plugback information before adding a new interval.
                                </p>
                            </Col>
                        </Row>
                        <Form>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Interval</Label>
                                        <EInput
                                            type="select"
                                            name="intervalType"
                                            id="intervalType"
                                            required={true}
                                            value={ this.state.interval.intervalType }
                                            onChange={this.handleModalChange}
                                        >
                                            <option value="" />
                                            { this.state.intervalTypes && this.state.intervalTypes.map((intervalType: string ,index: number) =>
                                                <option key={index} value={intervalType}>{intervalType}</option>
                                            ) }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Start Date</Label>
                                        <DateTime
                                            value={ this.state.interval.startDate ? moment.unix(Number(this.state.interval.startDate)).tz(this.state.well.timeZoneName) : undefined }
                                            onChange={this.handleStartDateTimeChange}
                                            inputProps={{disabled: this.state.well.wellStatus !== 'Active'}}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                        <EButton color="primary" onClick={this.handleSave}>Add Interval</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouter(CasingAndInterval);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/HoleGeometry/CasingAndInterval/CasingAndInterval.tsx